import * as React from 'react';
import XSmallOutlined from './x-small-outlined';
import XSmallFilled from './x-small-filled';
import type { IconCombinedProps } from './types';
const XSmallCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <XSmallFilled ref={ref} {...rest} />;
  }
  return <XSmallOutlined ref={ref} {...rest} />;
});
export default XSmallCombined;